import { getThemeColor } from '@fairfashion/design-system'
import { Handle } from 'reactflow'
import { css, styled } from 'styled-components'

export const Node = styled.div`
  width: 220px;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing['2']};
  background: ${({ theme }) => theme.colors.custom.white};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  border-radius: 8px;
  padding: 12px;
  pointer-events: all;
  border: 1px solid ${({ theme }) => theme.colors.grey_5};
  position: relative;
`

export const SegmentText = styled.small<{ color: string }>`
  font-size: 10px;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  text-align: left;
  gap: 0.25rem;

  & span {
    display: block;
    aspect-ratio: 1/1;
    width: 6px;
    height: 6px;
    background: ${(props) => props.color};
    border-radius: 50%;
  }
`

export const SmallText = styled.span<{ color: string }>`
  font-size: 10px;
  text-align: left;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px 0;
  text-transform: capitalize;

  color: ${(props) =>
    props.color
      ? getThemeColor(props.color, props.theme)
      : props.theme.colors.grey_1};
`

export const StatusText = styled.div`
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  background-color: #e8e8e8;
  color: #aaaaaa;
  font-size: 10px;
`

export const CustomHandle = styled(Handle)`
  min-height: 0;
  height: 0;
  opacity: 0;
`

export const ExpandButtonNext = styled.div<{ direction: 'TB' | 'LR' }>`
  position: absolute;
  ${({ direction }) =>
    direction === 'TB'
      ? css`
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
        `
      : css`
          right: -10px;
          top: 50%;
          transform: translateY(-50%);
        `};
  border: 2px solid ${({ theme }) => getThemeColor('secondary', theme)};
  background-color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const ExpandButtonPrevious = styled.div<{ direction: 'TB' | 'LR' }>`
  position: absolute;
  ${({ direction }) =>
    direction === 'TB'
      ? css`
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
        `
      : css`
          left: -10px;
          top: 50%;
          transform: translateY(-50%);
        `};
  border: 2px solid ${({ theme }) => getThemeColor('secondary', theme)};
  background-color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
